import { Entity } from '@backstage/catalog-model';
import {
  TECHDOCS_ANNOTATION,
  TECHDOCS_EXTERNAL_ANNOTATION,
} from '@backstage/plugin-techdocs-common';
import { STATICDOCS_ANNOTATION } from '../static-docs/constant';

/**
 * Whether the entity declares documentation: TechDocs of its own, the TechDocs
 * of another entity, or static docs. Decides whether the Docs tab is shown.
 */
export const hasDocsAnnotation = (entity: Entity): boolean => {
  const annotations = entity.metadata.annotations ?? {};
  return Boolean(
    annotations[TECHDOCS_ANNOTATION] ||
    annotations[TECHDOCS_EXTERNAL_ANNOTATION] ||
    annotations[STATICDOCS_ANNOTATION],
  );
};
